import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, PageTitle } from "./AdminLayout";
import { EventPicker } from "./EventPicker";
import { EventRoutes } from "./EventRoutes";

export default function RoutesAdmin() {
  const [eid, setEid] = useState(null);
  const [event, setEvent] = useState(null);
  useEffect(() => {
    if (eid) api.get(`/admin/events/${eid}`).then((r) => setEvent(r.data));
  }, [eid]);
  return (
    <div>
      <PageTitle title="Jalur" desc="Tambah, ubah tipe, durasi rotasi, buka/tutup jalur per event.">
        <EventPicker value={eid} onChange={setEid} testid="routes-event-picker" />
      </PageTitle>
      {event && <Panel title={event.name}><EventRoutes event={event} setEvent={setEvent} /></Panel>}
    </div>
  );
}
